import * as DocsConfig from '@tencent/docs-config';

const { ConfigItem } = DocsConfig;

export enum CM_ENV {
    DEV = 0, // 开发
    RELEASE = 1, // 正式
}
export class TitleBarConfig extends ConfigItem {
    public static readonly configName = 'titlebar';
    public static readonly back = TitleBarConfig.getKey('back');
    public static readonly logo = TitleBarConfig.getKey('logo');
    public static readonly title = TitleBarConfig.getKey('title');
    public static readonly collect = TitleBarConfig.getKey('collect');
    public static readonly move = TitleBarConfig.getKey('move');
    public static readonly collaborators = TitleBarConfig.getKey('collaborators');
    public static readonly share = TitleBarConfig.getKey('share');
    public static readonly saveTip = TitleBarConfig.getKey('saveTip');
    public static readonly auth = TitleBarConfig.getKey('auth');
    public static readonly account = TitleBarConfig.getKey('account');
    public static readonly rename = TitleBarConfig.getKey('rename');
    public static readonly fileMenu = TitleBarConfig.getKey('fileMenu');
    public static readonly collapseMenu = TitleBarConfig.getKey('collapseMenu');
    public static readonly mainMenu = TitleBarConfig.getKey('mainMenu');
    public static readonly remotePlay = TitleBarConfig.getKey('remotePlay');
    public static readonly remoteMeetingPlay = TitleBarConfig.getKey('remoteMeetingPlay');
    public static readonly presentView = TitleBarConfig.getKey('presentView');
    public static readonly mobileRemoteControl = TitleBarConfig.getKey('mobileRemoteControl');
    public static readonly playAction = TitleBarConfig.getKey('playAction');
    public static readonly external = TitleBarConfig.getKey('external');
    public static readonly saveState = TitleBarConfig.getKey('saveState');
    public static readonly readOnly = TitleBarConfig.getKey('readOnly');
    public static readonly member = TitleBarConfig.getKey('member');
    public static readonly print = TitleBarConfig.getKey('print');
    public static readonly aiAssistant = TitleBarConfig.getKey('aiAssistant');
}

export class ToolBarConfig extends ConfigItem {
    public static readonly configName = 'toolbar';
    public static readonly toolbar = ToolBarConfig.getKey('toolbar');
    public static readonly slide = ToolBarConfig.getKey('slide');
}

export class BlankPageConfig extends ConfigItem {
    public static readonly configName = 'custom.blankpage';
    public static readonly errImg = BlankPageConfig.getKey('errImg');
    public static readonly comment = BlankPageConfig.getKey('comment');
    public static readonly back = BlankPageConfig.getKey('back');
    public static readonly login = BlankPageConfig.getKey('login');
    public static readonly refresh = BlankPageConfig.getKey('refresh');
    public static readonly switchAccount = BlankPageConfig.getKey('switchAccount');
    public static readonly watchOfficeAccount = BlankPageConfig.getKey('watchOfficeAccount');
    public static readonly applyEditPermission = BlankPageConfig.getKey('applyEditPermission');
    public static readonly applyViewPermission = BlankPageConfig.getKey('applyViewPermission');
    public static readonly feedbackQuestion = BlankPageConfig.getKey('feedbackQuestion');
    public static readonly footer = BlankPageConfig.getKey('footer');
}

export class StatusBarConfig extends ConfigItem {
    public static readonly configName = 'statusbar';
    public static readonly statusBar = StatusBarConfig.getKey('statusBar');
    public static readonly playBtn = StatusBarConfig.getKey('playBtn');
}

export class WidgetConfig extends ConfigItem {
    public static readonly configName = 'widget';
    public static readonly helpCenter = WidgetConfig.getKey('helpCenter');
    // 拉端引导
    public static readonly appGuide = WidgetConfig.getKey('appGuide');
}

/**
 * 以上是 config-manager 有对应映射的配置
 * 以下是针对 ppt 自身定制化的配置/tob老旧配置
 */

export class AccountConfig extends ConfigItem {
    public static readonly configName = 'account';

    public static readonly systemNotice = AccountConfig.getKey('systemNotice');
    public static readonly accountManagement = AccountConfig.getKey('accountManagement');
    public static readonly switchAccount = AccountConfig.getKey('switchAccount');
    public static readonly logout = AccountConfig.getKey('logout');
}

/** @deprecated 已经没有这个配置了，只有 weboffice 场景强行写了两项 */
export class MainMenuConfig extends ConfigItem {
    public static readonly configName = 'mainmenu';

    // public static readonly create = MainMenuConfig.getKey('create');
    public static readonly saveAsFile = MainMenuConfig.getKey('saveAsFile');
    // public static readonly saveAsTemplate = MainMenuConfig.getKey('saveAsTemplate');
    // public static readonly saveAsShortcut = MainMenuConfig.getKey('saveAsShortcut');
    public static readonly generateCopy = MainMenuConfig.getKey('generateCopy');
    // public static readonly changeRecord = MainMenuConfig.getKey('changeRecord');
    // public static readonly readRecord = MainMenuConfig.getKey('readRecord');
    // public static readonly transferAuth = MainMenuConfig.getKey('transferAuth');
    // public static readonly about = MainMenuConfig.getKey('about');
    // public static readonly helper = MainMenuConfig.getKey('helper');
    // public static readonly support = MainMenuConfig.getKey('support');
    // public static readonly userReport = MainMenuConfig.getKey('userReport');
}

/**
 * 三条杠菜单
 */
export class FileMenuConfig extends ConfigItem {
    public static readonly configName = 'menu';
    /** 导出为 */
    public static readonly exportAs = FileMenuConfig.getKey('exportAs');
    /** 生成副本 */
    public static readonly clone = FileMenuConfig.getKey('clone');
    /** 上传新版本 */
    public static readonly addRevision = FileMenuConfig.getKey('addRevision');
    /** 右上角菜单顶部横向菜单 */
    public static readonly horMenu = FileMenuConfig.getKey('horMenu');
    public static readonly rename = FileMenuConfig.getKey('rename');
    /** 右上角菜单的无障碍开关 */
    public static readonly showAccessibility = FileMenuConfig.getKey('showAccessibility');
}

export class MobileConfig extends ConfigItem {
    public static readonly configName = 'custom.mobile';
    public static readonly mobileBackHome = MobileConfig.getKey('mobileBackHome');
    public static readonly titleBar = MobileConfig.getKey('titleBar');
    public static readonly titleBarCloud = MobileConfig.getKey('titleBar.uploadToCloud');
    public static readonly titleBarCloudSuccess = MobileConfig.getKey('titleBar.uploadToCloudSuccess');
    public static readonly titleBarShare = MobileConfig.getKey('titleBar.share');
    public static readonly titleBarGuideTip = MobileConfig.getKey('titleBar.guideTip');
    public static readonly titleBarLogo = MobileConfig.getKey('titleBar.logo');
    public static readonly collaborator = MobileConfig.getKey('titleBar.collaborator');
    public static readonly titleBarEdit = MobileConfig.getKey('titleBar.edit');
    public static readonly titleBarPlay = MobileConfig.getKey('titleBar.play');
    public static readonly titleBarOffline = MobileConfig.getKey('titleBar.offline');
    public static readonly bottomBarTogether = MobileConfig.getKey('bottomBar.togetherEdit');
    public static readonly bottomBarNote = MobileConfig.getKey('bottomBar.note');
    public static readonly bottomBarOperate = MobileConfig.getKey('bottomBar.operate');
    public static readonly navigateToH5Share = MobileConfig.getKey('shareMethods.navigateToH5');
    public static readonly hideGuideSaveToMydoc = MobileConfig.getKey('hideGuideSaveToMydoc');
    public static readonly infoStar = MobileConfig.getKey('infoStar');
    public static readonly hideTitlebar = MobileConfig.getKey('hideTitlebar');
    public static readonly hideBottomToolbar = MobileConfig.getKey('hideBottomToolbar');
    public static readonly titlebarLoginBtn = MobileConfig.getKey('titleBar.loginBtn');
    public static readonly titlebarForceGuideTip = MobileConfig.getKey('titleBar.forceGuideTip');
    public static readonly hideNickNameplate = MobileConfig.getKey('topHeader.hideNickNameplate');
    // mobile 更多菜单项，key 值跟默认 menu 配置保持一致
    public static readonly exportFile = MobileConfig.getKey('exportFile');
    public static readonly exportImage = MobileConfig.getKey('exportImage');
    public static readonly transferFile = MobileConfig.getKey('transferFile');
    public static readonly transferMutiEdit = MobileConfig.getKey('transferMutiEdit');
    public static readonly fileUpload = MobileConfig.getKey('fileUpload');
    public static readonly convertToPDF = MobileConfig.getKey('convertToPDF');
    public static readonly duplicate = MobileConfig.getKey('duplicate');
    public static readonly setAuth = MobileConfig.getKey('setAuth');
    public static readonly applyAuth = MobileConfig.getKey('applyAuth');
    public static readonly shareAndSend = MobileConfig.getKey('shareAndSend');
    public static readonly moveTo = MobileConfig.getKey('moveTo');
    public static readonly saveTemplate = MobileConfig.getKey('saveTemplate');
    public static readonly visitHistory = MobileConfig.getKey('visitHistory');
    public static readonly cache = MobileConfig.getKey('cache');
    public static readonly highlightTitle = MobileConfig.getKey('highlightTitle');
    public static readonly insertNewPictureAudioVideo = MobileConfig.getKey('insertNewPictureAudioVideo');
    public static readonly anonymousView = MobileConfig.getKey('anonymousView');
    public static readonly sendToPc = MobileConfig.getKey('sendToPc');
    public static readonly certification = MobileConfig.getKey('certification');
    public static readonly feedback = MobileConfig.getKey('feedback');
    public static readonly print = MobileConfig.getKey('print');
    public static readonly rename = MobileConfig.getKey('rename');
    public static readonly saveLocalFile = MobileConfig.getKey('saveLocalFile');
    public static readonly exit = MobileConfig.getKey('exit');
    public static readonly fileInfo = MobileConfig.getKey('fileInfo');
    public static readonly driveState = MobileConfig.getKey('driveState');
    public static readonly collect = MobileConfig.getKey('collect');
    public static readonly exitDocument = MobileConfig.getKey('exitDocument');
}

export class PlayerConfig extends ConfigItem {
    public static readonly configName = 'custom.player';

    public static readonly showToolBar = PlayerConfig.getKey('showToolBar');
    public static readonly pageTurnerBtn = PlayerConfig.getKey('pageTurnerBtn');

    // 翻页工具后的分隔线
    public static readonly splitLine1 = PlayerConfig.getKey('splitLine1');
    public static readonly userListBtn = PlayerConfig.getKey('userListBtn');
    public static readonly remoteShowBtn = PlayerConfig.getKey('remoteShowBtn');
    public static readonly meetingBtn = PlayerConfig.getKey('meetingBtn');

    // 麦克风按钮后的分隔线
    public static readonly splitLine2 = PlayerConfig.getKey('splitLine2');
    public static readonly noteBtn = PlayerConfig.getKey('noteBtn');
    public static readonly laserBtn = PlayerConfig.getKey('laserBtn');

    // 激光笔按钮后的分隔线
    public static readonly splitLine3 = PlayerConfig.getKey('splitLine3');
    public static readonly fullScreenBtn = PlayerConfig.getKey('fullScreenBtn');
    public static readonly presentView = PlayerConfig.getKey('presentView');
    public static readonly quitBtn = PlayerConfig.getKey('quitBtn');
    // 单独播放态的退出按钮
    public static readonly quitBtnInPlayer = PlayerConfig.getKey('quitBtnInPlayer');
    // 演示工具栏常驻
    public static readonly alwaysShow = PlayerConfig.getKey('alwaysShow');
    // 工具栏位置，左下或右下
    public static readonly position = PlayerConfig.getKey('position');
}

export class CustomConfig extends ConfigItem {
    public static readonly configName = 'custom';
    public static readonly logoCombination = CustomConfig.getKey('logoCombination');
    public static readonly useNativePassword = CustomConfig.getKey('useNativePassword');
    public static readonly showNote = CustomConfig.getKey('showNote');
    public static readonly newLocalFileTransfer = CustomConfig.getKey('newLocalFileTransfer');
}

export class TitlebarFileMenuConfig extends ConfigItem {
    public static readonly configName = 'custom.titlebarFileMenu';
    /** 精简模式 */
    public static readonly simplifyMode = TitlebarFileMenuConfig.getKey('simplifyMode');
    public static readonly exportPpt = TitlebarFileMenuConfig.getKey('exportPpt');
    public static readonly exportPdf = TitlebarFileMenuConfig.getKey('exportPdf');
    public static readonly exportShortcut = TitlebarFileMenuConfig.getKey('exportShortcut');
}

export class ToolbarFileMenuConfig extends ConfigItem {
    /** 桌面端本地编辑模式 */
    public static readonly configName = 'custom.toolbarFileMenu';

    // 本地编辑需屏蔽功能
    public static readonly authMenu = ToolbarFileMenuConfig.getKey('authMenu');
    public static readonly waterMark = ToolbarFileMenuConfig.getKey('waterMark');
    public static readonly insertLatex = ToolbarFileMenuConfig.getKey('insertLatex');
    public static readonly insertDoc = ToolbarFileMenuConfig.getKey('insertDoc');
    public static readonly insertLocalFile = ToolbarFileMenuConfig.getKey('insertLocalFile');
    public static readonly insertAddon = ToolbarFileMenuConfig.getKey('insertAddon');
    public static readonly addonUnofficial = ToolbarFileMenuConfig.getKey('addonUnofficial');
    public static readonly addonUnofficialIframe = ToolbarFileMenuConfig.getKey('addonUnofficialIframe');
    public static readonly transferAuth = ToolbarFileMenuConfig.getKey('transferAuth');
    public static readonly saveTemp = ToolbarFileMenuConfig.getKey('saveTemp');
    public static readonly cloudFont = ToolbarFileMenuConfig.getKey('cloudFont');
    public static readonly OCR = ToolbarFileMenuConfig.getKey('OCR');
    public static readonly helpFeedback = ToolbarFileMenuConfig.getKey('helpFeedback');
    public static readonly exportImg = ToolbarFileMenuConfig.getKey('exportImg');
    public static readonly exportImgVip = ToolbarFileMenuConfig.getKey('exportImgVip');
    public static readonly usePrivateAuthMenu = ToolbarFileMenuConfig.getKey('usePrivateAuthMenu');
    public static readonly importFile = ToolbarFileMenuConfig.getKey('importFile'); // 导入幻灯片(右键菜单 & 拖拽)
    public static readonly downloadMedia = ToolbarFileMenuConfig.getKey('downloadMedia'); // 下载媒体文件(单击悬浮菜单 & 右键菜单)
    public static readonly copyLink = ToolbarFileMenuConfig.getKey('copyLink');
    public static readonly revisionRecord = ToolbarFileMenuConfig.getKey('revisionRecord');
    public static readonly readRecord = ToolbarFileMenuConfig.getKey('readRecord');
    public static readonly fileInfo = ToolbarFileMenuConfig.getKey('fileInfo');
    public static readonly highlightTitle = ToolbarFileMenuConfig.getKey('highlightTitle');
    public static readonly tailorVideo = ToolbarFileMenuConfig.getKey('tailorVideo');
    public static readonly setVideoCover = ToolbarFileMenuConfig.getKey('setVideoCover');
    public static readonly convertToPDF = ToolbarFileMenuConfig.getKey('convertToPDF');
    public static readonly toolbarBeautify = ToolbarFileMenuConfig.getKey('toolbarBeautify'); // 专业工具栏，美化tab
    public static readonly picHandleToolbar = ToolbarFileMenuConfig.getKey('picHandleToolbar'); // 美化tab,图片处理
    public static readonly fontHandler = ToolbarFileMenuConfig.getKey('fontHandler'); // 美化tab,统一字体
    public static readonly quickTool = ToolbarFileMenuConfig.getKey('quickTool'); // 快捷美化入口
    public static readonly toolbarVip = ToolbarFileMenuConfig.getKey('toolbarVip'); // 会员专享入口
    public static readonly exitDocument = ToolbarFileMenuConfig.getKey('exitDocument');
    public static readonly insertNewPictureAudioVideo = ToolbarFileMenuConfig.getKey('insertNewPictureAudioVideo');
    public static readonly anonymousView = ToolbarFileMenuConfig.getKey('anonymousView');
    public static readonly changeTemplateContent = ToolbarFileMenuConfig.getKey('changeTemplateContent');
    public static readonly changeTemplateMore = ToolbarFileMenuConfig.getKey('changeTemplateMore');
    public static readonly toolbarEfficiency = ToolbarFileMenuConfig.getKey('toolbarEfficiency');
    public static readonly aiGeneratePage = ToolbarFileMenuConfig.getKey('aiGeneratePage');
    public static readonly aiGenerateText = ToolbarFileMenuConfig.getKey('aiGenerateText');

    // titlebar新增本地编辑独有功能逻辑
    public static readonly localFileSaveAs = ToolbarFileMenuConfig.getKey('localFileSaveAs');
    public static readonly localFileSave = ToolbarFileMenuConfig.getKey('localFileSave');
    public static readonly localFileFolder = ToolbarFileMenuConfig.getKey('localFileFolder');
    public static readonly recommendLayout = ToolbarFileMenuConfig.getKey('recommendLayout');
    public static readonly ocr = ToolbarFileMenuConfig.getKey('ocr');
}

/**
 * 预览态新增配置项
 */
export class PreviewConfig extends ConfigItem {
    public static readonly configName = 'custom.preview';
    public static readonly hideAddSlide = PreviewConfig.getKey('hideAddSlide');
}

/**
 * 右侧侧边栏功能配置项
 */
export class RightDrawerMenuConfig extends ConfigItem {
    public static readonly configName = 'custom.rightDrawerMenu';
    public static readonly hidePictureFix = RightDrawerMenuConfig.getKey('hidePictureFix'); // 图片校正
    public static readonly hidePictureEffect = RightDrawerMenuConfig.getKey('hidePictureEffect'); // 图片效果
}
